export const BIKE_BONUS_PREMIUM = 'bike_bonus'
export const COLD_WEATHER_BONUS_PREMIUM = 'cold_weather_bonus'
export const DIMONA_PREMIUM = 'dimona'
export const ECO_CHEQUE_PREMIUM = 'eco_cheque'
export const KILOMETER_COMPENSATION_PREMIUM = 'kilometer_compensation'
export const LATE_SHIFT_BONUS_PREMIUM = 'late_shift_bonus'
export const MEAL_VOUCHERS_PREMIUM = 'meal_vouchers'
export const MOBILITY_PREMIUM = 'mobility'
export const MORNING_SHIFT_BONUS_PREMIUM = 'morning_shift_bonus'
export const NIGHT_SHIFT_BONUS_PREMIUM = 'night_shift_bonus'
export const OTHER_PREMIUM = 'other'
export const SOCIAL_KILOMETER_COMPENSATION_PREMIUM =
  'social_kilometer_compensation'
